import "./portfolio.css";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import { portfolioData } from "../../../data/PortfolioData";
import { useState, useEffect } from "react";
import Heading from "../../heading/Heading";
import PortfolioCard from "../../portfolio-card/PortfolioCard";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation } from "swiper";

const Portfolio = () => {
  const [slideItems, setSlideItems] = useState(4);
  const [space, setSpace] = useState(10);

  const width = window.innerWidth;

  useEffect(() => {
    if (width <= 1505) {
      setSlideItems(4);
      setSpace(5);
    }
  }, [width]);

  useEffect(() => {
    if (width <= 1240) {
      setSlideItems(3);
      setSpace(5);
    }
  }, [width]);

  useEffect(() => {
    if (width <= 800) {
      setSlideItems(2);
      setSpace(5);
    }
  }, [width]);

  useEffect(() => {
    if (width <= 425) {
      setSlideItems(1);
      setSpace(5);
    }
  }, [width]);

  return (
    <div className="portfolio " id="portfolio">
      <Heading word="Portfolio" headingSize="h1" />
      <Swiper
        slidesPerView={slideItems}
        spaceBetween={space}
        freeMode={true}
        grabCursor={true}
        navigation={true}
        modules={[FreeMode, Navigation]}
        className="mySwiper"
      >
        {portfolioData.map((portfolio) => (
          <SwiperSlide key={portfolio.id}>
            <PortfolioCard {...portfolio} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Portfolio;
